import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import qs from "query-string";

import "./Login.css";
import config from "../constants/config";
import { validateThenLogin } from "../actions/auth";
import { LoginInput, PasswordInput } from "../components/Input";
import SignInButton from "../components/Buttons/SignInButton";
import WhiteLoginButton from "../components/Buttons/WhiteLoginButton";
import OrDivider from "../components/Divider/OrDivider";
import GoogleLoginButton from "../components/Buttons/GoogleLoginButton";

class Login extends React.Component {
  state = { email: "", password: "" };

  componentWillMount() {
    // get jwt from url
    const params = qs.parse(this.props.location.search);
    if (params.token) {
      this.props.validateThenLogin(params.token);
    }
  }

  googleLogin = () => {
    const link = `${config.API_ENDPOINT}/auth/google`;
    window.location.href = link;
  };

  localLogin = async () => {
    const { name, email, password } = this.state;

    // validate fields
    if (
      email === "" ||
      password === "" ||
      (name === "" && !this.props.loginModal)
    ) {
      return this.setState({ loginErr: "One of the above fields is empty" });
    } else if (this.props.auth.error) {
      console.log(this.props.auth.error);
      return this.setState({ loginErr: "Server error" });
    }

    // try login
    const res = await fetch(
      `${config.API_ENDPOINT}/auth/local?${qs.stringify({
        name,
        email,
        password
      })}`
    )
      .then(resp => {
        if (resp.ok) return resp.json();
        else console.log("error logging in");
      })
      .catch(err => console.log(err));

    if (res && res.status >= 400) {
      this.setState({ loginErr: res.message });
    } else {
      // update redux
      this.props.validateThenLogin(res.token);
    }
  };

  onInputChange = (field, value) => {
    const newState = { [field]: value };
    if (this.state.loginErr && value !== "") newState.loginErr = undefined;

    this.setState(newState);
  };

  render() {
    const isMerchantLogin =
      this.props.history.location.pathname.search("merchant") !== -1;

    return (
      <div className="backgroundDiv">
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          {isMerchantLogin ? (
            <WhiteLoginButton title="CUSTOMER LOGIN" to="/" />
          ) : (
            <WhiteLoginButton title="MERCHANT LOGIN" to="/merchant" />
          )}
        </div>
        <div
          style={{
            flex: 1,
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 170
          }}
        >
          <img
            src={require("../assets/login_logo.png")}
            alt="safebox logo"
            width="100%"
            style={{ maxWidth: 500 }}
          />
          {isMerchantLogin && <h4 style={{ marginTop: 0 }}>Merchant Login</h4>}
        </div>

        <form onSubmit={e => e.preventDefault()}>
          <LoginInput
            type="email"
            placeholder="Your email"
            autoComplete="username email"
            onChange={event => this.onInputChange("email", event.target.value)}
            value={this.state.email}
          />
          <PasswordInput
            placeholder="Your password"
            autoComplete="password"
            onChange={event =>
              this.onInputChange("password", event.target.value)
            }
            value={this.state.password}
          />
          {this.state.loginErr && (
            <p style={{ textAlign: "center", color: "red", margin: 0 }}>
              {this.state.loginErr}
            </p>
          )}

          <SignInButton onClick={this.localLogin} />
        </form>
        {!isMerchantLogin && (
          <div>
            <OrDivider />
            <GoogleLoginButton onClick={this.googleLogin} />
          </div>
        )}

        <div style={{ width: "100%", padding: 20 }}>
          <WhiteLoginButton title="FORGOT DETAILS?" to="/" />
          <WhiteLoginButton
            title="CREATE ACCOUNT"
            linkStyle={{ float: "right" }}
            to="/create/account"
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  validateThenLogin: token => dispatch(validateThenLogin(token))
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Login));
